import { CopilotConversationDTO } from './copilotConversationDTO';

export class AutomationCandidateDTO {
  id?: string;

  title?: string;

  proves?: string;

  evidenceSource?: string;

  kind?: string;

  checkKey?: string;

  readiness?: number;

  capabilityKey?: string;

  missingCapabilities?: string[];

  existingSkillKey?: string;
}

export class AutomationDraftProposalDTO {
  isRevision?: boolean;

  key?: string;

  name?: string;

  description?: string;

  category?: string;

  skillMd?: string;

  skillYaml?: string;

  changeSummary?: string;

  proposedVersion?: string;

  notes?: string[];

  yamlErrors?: string[];
}

export class AutomationDraftStateDTO {
  proposal?: AutomationDraftProposalDTO;

  skillId?: string;

  versionId?: string;

  version?: string;

  versionStatus?: string;

  skillKey?: string;

  skillName?: string;

  testCaseCount?: number;

  lastTestOutcome?: string;
}

export class AutomationApprovalStateDTO {
  submitted?: boolean;

  versionStatus?: string;

  approved?: boolean;

  published?: boolean;

  needsAdmin?: boolean;

  reason?: string;
}

export class AutomationWireStateDTO {
  wired?: boolean;

  integrationId?: number;

  kpiId?: number;

  checkKey?: string;

  kpiName?: string;

  error?: string;
}

export class AutomationScheduleStateDTO {
  choice?: string;

  scheduleId?: string;

  error?: string;
}

// The Data of the AutomationDrafting process row (ProcessStateAutomationDrafting). The client sends the conversation
// and, with a stage action, the command (accept, test, select:<id|fresh>, schedule:<choice>); the server fills the rest.
export class TenantProcessStateAutomationDraftingDTO {
  stage?: number;

  inputAllowed?: boolean;

  actions?: string[];

  command?: string;

  entityType?: number;

  entityId?: number;

  entityCode?: string;

  candidates?: AutomationCandidateDTO[];

  selectedCandidateId?: string;

  draft?: AutomationDraftStateDTO;

  approval?: AutomationApprovalStateDTO;

  wire?: AutomationWireStateDTO;

  schedule?: AutomationScheduleStateDTO;

  conversation: CopilotConversationDTO;

  constructor() {
    this.conversation = new CopilotConversationDTO();
  }
}
